// Forked from ../../ResultsDropdown/GroupGuidelines.tsx — keep in sync until phase_0 cleanup.
import React from 'react';
import ParseHtml from 'html-react-parser';
import { IconFile } from '@bynder/icons';
import type { Guideline } from '../../types';
import { iconSizeExtraLarge } from '../../../../helpers/iconSizes';
import { navigateTo } from '../../../../helpers/windowLocation';
import { ListRow } from './ListRow';
import { getSpotlightResultClassName } from '../../helpers/getSpotlightResultClassName';
import { GUIDELINE_TITLE, parseHighlightedText } from '../../helpers/highlightedText';
import { StyledImgWrapper } from '../SharedComponents';
import { HighlightedText } from '../HighlightedText';

type Props = {
	guidelines: Guideline[];
};

export function GroupGuidelines({ guidelines }: Props) {
	return (
		<>
			{guidelines.map((guideline) => (
				<ListRow
					dataId={guideline.id}
					onSelect={() => navigateTo(guideline.path)}
					className={getSpotlightResultClassName('Guideline')}
					key={guideline.id}
					thumbnail={
						<StyledImgWrapper>
							{guideline.iconSvg ? (
								// We trust guideline.iconSvg to be safe: it is one of guidelines-search-svc's hardcoded icons, not user-generated data.
								ParseHtml(guideline.iconSvg)
							) : (
								<IconFile size={iconSizeExtraLarge} />
							)}
						</StyledImgWrapper>
					}
					title={
						<HighlightedText
							segments={parseHighlightedText(guideline.title, GUIDELINE_TITLE)}
						/>
					}
				/>
			))}
		</>
	);
}
